import React, {useState} from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';

import AuthService from "../Authentication/AuthService";
import swal from "sweetalert";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";

const searchItem =
{
    newPassword: "",
    confirmPassword: "",
}
let currentUser = JSON.parse(localStorage.getItem("currentUser"));

class ChangePassword extends React.Component {
    authService;
    constructor(props) {
        super(props);
        this.authService = new AuthService();
        this.state = {
            searchData: {
                newPassword: "",
                confirmPassword: "",
            },
            currentUser: ""
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.SubmitData = this.SubmitData.bind(this);
        this.hideSidePanel = this.hideSidePanel.bind(this);
    }
    componentDidMount() {
        var _this = this;
        _this.authService.getCurrentUserDetails().then(function (user) {
            _this.setState({ currentUser: user });
            _this.props.dispatch({ type: "UserRole", data: user.role });
            _this.props.dispatch({ type: "AuthenticatedUserInformation", data: user });
        });
        this.props.dispatch({ type: 'SubBannerTitle', data: "Change Password" });
    }

    handleInputChange(e) {
        let nodeName = e.target.name;
        this.state.searchData[nodeName] = e.target.value;
        this.setState({});
    }
    SubmitData() {
        const { dispatch, userDetail, history } = this.props;
        let data={
            mail: `${btoa(userDetail.email)}`,
            password: `${btoa(this.state.searchData.newPassword)}`,
            confirmPassword: `${btoa(this.state.searchData.confirmPassword)}`
          }
        let password = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[a-zA-Z]).{8,}$/
        if (this.state.searchData.newPassword === this.state.searchData.confirmPassword && this.state.searchData.newPassword !== "" && this.state.searchData.confirmPassword !== "" && password.test(this.state.searchData.newPassword)) {
            let url = `${API.password}`;
            axios.put(url, data,{
                headers: {
                  key: currentUser.accessToken
                }
              })
          .then((response) => {
            if(response.status===500){
                swal("Error!", "Error when adding the data. Try again.", "warning");
              }else{
                    history.goBack();
                    dispatch({
                        type: 'getPasswordSuccess',
                        data: response.data
                    })
                    if (response.data) {
                        toast.success('Password Changed Successfully', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                }
                })
                .catch((error) => {
                    swal("Error!", "Something went wrong. Please try again.", "warning");
                    dispatch({
                        type: 'getPasswordFailure',
                        data: "error"
                    })
                })
        }
        else if (this.state.searchData.newPassword == "" && this.state.searchData.confirmPassword == "") {
            swal('Error!', 'Password cannot be empty', 'warning');
        }
        else if (this.state.searchData.newPassword !== this.state.searchData.confirmPassword) {
            swal('Error!', 'Password does not match', 'warning');
        }
        else {
            swal('Error!', 'Password Invalid.Try a mix of letters, numbers and symbols', 'warning')
        }
    }

    hideSidePanel() {
        this.props.history.goBack();
        this.props.dispatch({ type: 'SubBannerTitle', data: false });
    }
    render() {
        return (
            <div className="row">
                <div className="col-sm-12 col-md-12">
                    <div className="panel-box search-filter-box mt-4 mx-4">
                        <div className="card MM-card-header mt-2 mb-0" style={{ backgroundColor: "white", border: "0px" }}>
                            <div className="card-body">
                                <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>
                                    Change Password
                                </h5>
                            </div>
                        </div>
                        <div className="search-filter-box">
                            
                            <div className="row">
                                <div className="col-lg-5">
                                    <label className="form-label">New Password</label>
                                    <br></br>
                                    <input
                                        className="form-control"
                                        type="password"
                                        name="newPassword"
                                        placeholder="New Password"
                                        value={this.state.searchData.newPassword}
                                        onChange={e => this.handleInputChange(e)}
                                    ></input>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-5">
                                    <label className="form-label">Confirm Password</label>
                                    <br></br>
                                    <input
                                        className="form-control"
                                        type="password"
                                        name="confirmPassword"
                                        placeholder="Confirm Password"
                                        value={this.state.searchData.confirmPassword}
                                        onChange={e => this.handleInputChange(e)}
                                    ></input>
                                </div>
                            </div>
    
                        </div>
                        <div className="row py-3" >
                            <div className="col-lg-5">
                                <div className="search-btn-col" style={{ textAlign: "end" }}>
                                    <button
                                        className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                        type="submit"
                                        onClick={() => this.SubmitData()}
                                    >
                                        {" "}Confirm{" "}
                                    </button>
                                    <button 
                                        className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                        type="button"
                                        onClick={() => this.hideSidePanel()}
                                    >
                                        {" "}Cancel{" "}
                                    </button>
                                </div>
                            </div>
                        </div>
    
                    </div>
                </div>
            </div>
                             
        );
    }

    
    
}
function mapStateToProps(state) {
    return {
        userDetail: state.SidePanReducer.userDetail
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangePassword));


